import { getContractBasedDataSelector } from '@cp-shared-9/frontend-integration';
import { RootState } from '../../../../store/rootReducer';

export const FinancialDetailsDataSelector = getContractBasedDataSelector((state: RootState) => state.financialDetails);
export const productNameCatalogContentSelector = (state: RootState) => state.content.productNames;
